export default __webpack_public_path__ + "static/media/age-&-fertility-banner.a16cdc77.jpg";